import { ContentPageLayout } from "@components/content-page/layout"
import { FC } from "react"
import { ContentPageItem, FooterSingleton } from "__generated__/sanity"
import { ContentPageContentBlocks } from "./content-blocks"

type ContentPageTemplateLegalProps = {
  footer: FooterSingleton
  content: ContentPageItem
}

export const ContentPageTemplateLegal: FC<ContentPageTemplateLegalProps> = ({
  content,
  footer,
}) => {
  return (
    <ContentPageLayout footer={footer} seo={content.seo}>
      <ContentPageContentBlocks blocks={content.cbBlocks || []} />
    </ContentPageLayout>
  )
}
